function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 40px;\n  margin-right: 26px;\n  padding-top: 2px;\n  color: #797e83;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  padding-top: 1px;\n"
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-size: 20px;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  &:after {\n    ",
        "\n    transform: translateY(-3px);\n  }\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import _ from 'lodash';
import styled from 'styled-components';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import AsyncCreatableSelect from 'react-select/async-creatable';
import AsyncSelect from 'react-select/async';
import { ArrowImage, ArrowCss } from './select-with-label';
function isValidNewOption(inputValue, _selectValue, selectOptions) {
    var hasCaseInsensitiveExactMatch = _.some(selectOptions, function(option) {
        return _.trim(option.label.toLowerCase()) === _.trim(inputValue.toLowerCase());
    });
    return inputValue.length > 0 && !hasCaseInsensitiveExactMatch;
}
// This is actually 3 components wrapped into 1:
// if isCreatable, return <CreatableSelect>
// else if isAsync, return <AsyncSelect>
// default return is <Select>
var ReactSelect = function(param) {
    var defaultValue = param.defaultValue, _param_height = param.height, height = _param_height === void 0 ? 45 : _param_height, _param_isAsyncCreatable = param.isAsyncCreatable, isAsyncCreatable = _param_isAsyncCreatable === void 0 ? false : _param_isAsyncCreatable, _param_isAsyncMulti = param.isAsyncMulti, isAsyncMulti = _param_isAsyncMulti === void 0 ? false : _param_isAsyncMulti, _param_isAsync = param.isAsync, isAsync = _param_isAsync === void 0 ? false : _param_isAsync, _param_isLoading = param.isLoading, isLoading = _param_isLoading === void 0 ? false : _param_isLoading, _param_loadOptions = param.loadOptions, loadOptions = _param_loadOptions === void 0 ? _.noop : _param_loadOptions, _param_isCreatable = param.isCreatable, isCreatable = _param_isCreatable === void 0 ? false : _param_isCreatable, _param_isMulti = param.isMulti, isMulti = _param_isMulti === void 0 ? false : _param_isMulti, _param_isSearchable = param.isSearchable, isSearchable = _param_isSearchable === void 0 ? true : _param_isSearchable, _param_isClearable = param.isClearable, isClearable = _param_isClearable === void 0 ? false : _param_isClearable, _param_id = param.id, id = _param_id === void 0 ? 'react-select' : _param_id, formatCreateLabel = param.formatCreateLabel, formatOptionLabel = param.formatOptionLabel, _param_noOptionsMessage = param.noOptionsMessage, noOptionsMessage = _param_noOptionsMessage === void 0 ? function() {
        return 'No options';
    } : _param_noOptionsMessage, onChange = param.onChange, onCreateOption = param.onCreateOption, _param_options = param.options, options = _param_options === void 0 ? [] : _param_options, _param_placeholder = param.placeholder, placeholder = _param_placeholder === void 0 ? 'Select...' : _param_placeholder, value = param.value, components = param.components, _param_textAlign = param.textAlign, textAlign = _param_textAlign === void 0 ? 'inherit' : _param_textAlign, _param_width = param.width, width = _param_width === void 0 ? 194 : _param_width, _param_borderRadius = param.borderRadius, borderRadius = _param_borderRadius === void 0 ? '2px' : _param_borderRadius, _param_containerStyles = param.containerStyles, containerStyles = _param_containerStyles === void 0 ? {} : _param_containerStyles, _param_optionStyles = param.optionStyles, optionStyles = _param_optionStyles === void 0 ? {} : _param_optionStyles, _param_customSelectedBackgroundColor = param.customSelectedBackgroundColor, customSelectedBackgroundColor = _param_customSelectedBackgroundColor === void 0 ? null : _param_customSelectedBackgroundColor, _param_customSelectedColor = param.customSelectedColor, customSelectedColor = _param_customSelectedColor === void 0 ? null : _param_customSelectedColor, _param_hasError = param.hasError, hasError = _param_hasError === void 0 ? false : _param_hasError, _param_tagPrefix = param.tagPrefix, tagPrefix = _param_tagPrefix === void 0 ? '' : _param_tagPrefix;
    var getOptionBgColor = function(isFocused, isSelected, isDisabled) {
        if (isSelected && customSelectedBackgroundColor) {
            return customSelectedBackgroundColor;
        }
        if (isDisabled) {
            return 'var(--dcm-checkout-input-bg, #FFF)';
        }
        if (isSelected) {
            return '#7A9ED5';
        }
        if (isFocused) {
            return 'var(--dcm-color-surface-hover, #F6F6F6)';
        }
        return 'var(--dcm-checkout-input-bg, #FFF)';
    };
    var getOptionColor = function(isSelected, isDisabled) {
        if (isDisabled) {
            return '#C6C6C6';
        }
        if (isSelected && customSelectedColor) {
            return customSelectedColor;
        }
        if (isSelected) {
            return '#FFF';
        }
        return 'var(--dcm-checkout-text-color, #6d747b)';
    };
    var styleOverrides = {
        container: function(styles) {
            return _object_spread({}, styles, containerStyles);
        },
        control: function(styles) {
            return _object_spread_props(_object_spread({}, styles), {
                cursor: 'pointer',
                width: width,
                minHeight: height,
                boxShadow: 'none',
                borderRadius: borderRadius,
                borderColor: hasError ? '#e25241' : 'var(--dcm-checkout-input-border-color, #d1d5da)',
                ':hover': {
                    borderColor: hasError ? '#e25241' : 'var(--dcm-checkout-input-border-color, #d1d5da)'
                },
                fontSize: '13px',
                color: 'var(--dcm-checkout-text-color, #6d747b)',
                backgroundColor: 'var(--dcm-checkout-input-bg, #fcfdfe)',
                paddingLeft: isMulti ? '13px' : '11px'
            });
        },
        menu: function(styles) {
            return _object_spread_props(_object_spread({}, styles), {
                zIndex: 100,
                backgroundColor: 'var(--dcm-checkout-input-bg, #fff)'
            });
        },
        option: function(styles, param) {
            var isFocused = param.isFocused, isSelected = param.isSelected, isDisabled = param.isDisabled;
            return _object_spread_props(_object_spread({}, styles, optionStyles), {
                cursor: isDisabled ? 'not-allowed' : 'pointer',
                fontSize: '13px',
                textAlign: textAlign,
                backgroundColor: getOptionBgColor(isFocused, isSelected, isDisabled),
                color: getOptionColor(isSelected, isDisabled),
                ':active': _object_spread_props(_object_spread({}, styles[':active']), {
                    color: customSelectedColor !== null && customSelectedColor !== void 0 ? customSelectedColor : '#fff',
                    backgroundColor: customSelectedBackgroundColor !== null && customSelectedBackgroundColor !== void 0 ? customSelectedBackgroundColor : '#7A9ED5'
                })
            });
        },
        singleValue: function(styles) {
            return _object_spread_props(_object_spread({}, styles), {
                color: 'var(--dcm-checkout-text-color, #707478)',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                height: '100%',
                top: '1px',
                transform: 'none'
            });
        },
        multiValue: function(styles) {
            return _object_spread_props(_object_spread({}, styles), {
                borderRadius: '3px',
                border: 'solid 1px #b7c2d0',
                backgroundColor: '#eaeff4',
                margin: '4px',
                ':first-of-type': {
                    marginLeft: 0
                }
            });
        },
        multiValueLabel: function(styles) {
            return _object_spread_props(_object_spread({}, styles), {
                color: '#606f7f',
                fontSize: '13px',
                fontWeight: 'bold'
            });
        },
        multiValueRemove: function(styles) {
            return _object_spread_props(_object_spread({}, styles), {
                color: ' #9aa8b6',
                ':hover': {}
            });
        }
    };
    var sharedProps = {
        id: id,
        onChange: onChange,
        options: options,
        placeholder: placeholder,
        styles: styleOverrides,
        value: value
    };
    if (isCreatable) {
        var customizedComponents = _object_spread({
            DropdownIndicator: null
        }, components);
        return /*#__PURE__*/ _jsx(CreatableSelect, _object_spread_props(_object_spread({}, sharedProps), {
            components: customizedComponents,
            isClearable: false,
            isMulti: true
        }));
    }
    var showClearable = isClearable && !_.isEmpty(value === null || value === void 0 ? void 0 : value.value);
    var customizedComponents1 = isMulti ? _object_spread({
        DropdownIndicator: null
    }, components) : _object_spread({
        IndicatorsContainer: showClearable ? ClearIndicatorWithArrow : ArrowImage
    }, components);
    if (isAsyncCreatable) {
        return /*#__PURE__*/ _jsx(AsyncCreatableSelect, _object_spread_props(_object_spread({}, sharedProps), {
            components: customizedComponents1,
            createOptionPosition: "last",
            formatCreateLabel: formatCreateLabel,
            isClearable: isClearable,
            isLoading: isLoading,
            isValidNewOption: isValidNewOption,
            loadOptions: loadOptions,
            onCreateOption: onCreateOption
        }));
    }
    if (isAsyncMulti) {
        return /*#__PURE__*/ _jsx(AsyncSelect, _object_spread_props(_object_spread({}, sharedProps), {
            isMulti: true,
            noOptionsMessage: noOptionsMessage,
            components: customizedComponents1,
            loadOptions: loadOptions,
            isClearable: isClearable
        }));
    }
    if (isAsync) {
        return /*#__PURE__*/ _jsx(AsyncSelect, _object_spread_props(_object_spread({}, sharedProps), {
            noOptionsMessage: noOptionsMessage,
            components: customizedComponents1,
            loadOptions: loadOptions,
            isClearable: isClearable
        }));
    }
    return /*#__PURE__*/ _jsx(Select, _object_spread_props(_object_spread({}, sharedProps), {
        components: customizedComponents1,
        defaultValue: defaultValue,
        isClearable: isClearable,
        isMulti: isMulti,
        isSearchable: isSearchable,
        noOptionsMessage: noOptionsMessage,
        formatOptionLabel: formatOptionLabel,
        classNamePrefix: tagPrefix
    }));
};
export default ReactSelect;
var ClearIndicatorWithArrow = function(param) {
    var clearValue = param.clearValue;
    return /*#__PURE__*/ _jsxs(ClearContainer, {
        children: [
            /*#__PURE__*/ _jsx(Clear, {
                onClick: clearValue,
                children: /*#__PURE__*/ _jsx("svg", {
                    viewBox: "0 0 14 14",
                    xmlns: "http://www.w3.org/2000/svg",
                    height: "10px",
                    width: "10px",
                    fill: "#797e83",
                    children: /*#__PURE__*/ _jsx("path", {
                        d: "m13.71 11.55-4.55-4.55 4.55-4.55c.6-.6.17-1.13-.43-1.73s-1.13-1-1.73-.43l-4.55 4.54-4.55-4.54c-.6-.6-1.13-.17-1.73.43s-1 1.13-.43 1.73l4.54 4.55-4.54 4.55c-.6.6-.17 1.13.43 1.73s1.13 1 1.73.43l4.55-4.55 4.55 4.55c.6.6 1.13.16 1.73-.43s1.03-1.14.43-1.73z"
                    })
                })
            }),
            /*#__PURE__*/ _jsx(Divider, {
                children: "|"
            }),
            /*#__PURE__*/ _jsx(Arrow, {})
        ]
    });
};
var ClearContainer = styled.div(_templateObject());
var Clear = styled.div(_templateObject1());
var Divider = styled.div(_templateObject2());
var Arrow = styled.div(_templateObject3(), ArrowCss);
